export default {
  ['UPLOAD_ADD'](state, payload) {
    state.files = [...state.files, payload];
  },
  ['UPLOAD_UPDATE'](state, payload) {
    state.files = state.files.map(file => (file.uid === payload.uid ? Object.assign({}, file, payload) : file));
  },
  ['UPLOAD_REMOVE'](state, payload) {
    state.files = state.files.filter(file => file.uid !== payload);
  },
  ['UPLOAD_CLEAR'](state) {
    state.files = [];
  },
  ['UPLOAD_CANCEL'](state, payload) {
    state.cancelToken = payload;
  },
}
